import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import { getData, useDataModule } from '@perpay-web/data-module/useDataModule';
import { CHECKOUT_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const getOrderRepaymentOptions = (state) =>
    getData(state).repaymentOptions;
export const getOrderPerpayPlusRepaymentOption = (state) =>
    getData(state).perpayPlusRepaymentOption;
export const getOrderProducts = (state) => getData(state).products;
export const getOrderShippingInfo = (state) => getData(state).shippingInfo;

const getOrderSummary = (state) => getData(state).summary;

export const getOrderTax = (state) => getOrderSummary(state).tax || 0;
export const getOrderSubTotal = (state) => getOrderSummary(state).subtotal || 0;
export const getOrderDiscount = (state) => getOrderSummary(state).discount || 0;
export const getOrderBorrowerCreditAmount = (state) =>
    getOrderSummary(state).onHoldCredits || 0;
export const getOrderTotal = (state) => getOrderSummary(state).total || 0;
export const getOrderRevenue = (state) => getOrderSummary(state).revenue;

const initialValue = {
    summary: {},
    products: [],
    shippingInfo: {},
    repaymentOptions: [],
    perpayPlusRepaymentOption: null,
};

const useFetchOrderInformationDataModule = () =>
    useDataModule(
        (checkoutUuid) =>
            authenticatedJsonFetch(
                CHECKOUT_ENDPOINT.replace(':uuid', checkoutUuid),
            ),
        { initialValue },
    );

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useFetchOrderInformationDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseFetchOrderInformationDataModuleProvider,
    useFetchOrderInformationContext,
] = createContextProvider(providerFactory);
